<app-accordion-item>
  <div app-accordion-header class="flex items-center justify-start gap-4" translate>
    <div>
      <input
        app-checkbox
        [ngModel]="isTrailSelected"
        class="text-theme-950"
        type="checkbox"
        (click)="onSelectTrail($event)"
      />
    </div>
    <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-gray-300">
      <img
        app-img
        class="h-12 w-12 select-none rounded-lg"
        [src]="trail.thumbnail"
        onerror="src='assets/images/default.png'"
      />
    </div>
    <div class="text-md font-medium text-theme-800">{{ trail.name }}</div>
  </div>
  <div
    class="absolute -left-[4.5%] -top-14 z-0 w-5 border border-b border-theme-500 opacity-70 md:w-6 2xl:w-8 3xl:w-10"
  ></div>
  <div app-accordion-content class="rounded-lg bg-linear-to-r from-white via-theme-50 to-theme-100">
    <div class="w-full">
      @for (session of trail.sessoes; track session) {
        <div>
          <div class="flex flex-col items-end justify-center pb-2">
            <div class="mb-2 w-11/12 border-b border-gray-300 text-md text-gray-500">
              {{ session.titulo }}
            </div>
          </div>
          @for (elemento of session.elementos; track elemento) {
            <div class="flex flex-col items-end justify-center pb-2">
              <div class="w-11/12 rounded-lg bg-white py-4 pl-4 shadow shadow-black/40">
                <div class="flex w-full items-center justify-between">
                  <div class="flex items-center justify-start gap-4">
                    <div>
                      <input
                        app-checkbox
                        [ngModel]="isElementSelected(elemento)"
                        class="text-theme-950"
                        type="checkbox"
                        (click)="onSelectElement(elemento, $event)"
                      />
                    </div>
                    <div>
                      <svg-icon
                        [ngClass]="typeText(elemento.tipo)"
                        class="flex w-8 justify-center group-hover:text-theme-contrast"
                        [src]="'assets/icons/' + typeIcon(elemento.tipo)"
                      ></svg-icon>
                    </div>
                    <div class="text-md text-theme-900">
                      {{ elemento.titulo }}
                    </div>
                  </div>
                  <div class="mr-4">
                    <button
                      app-flat-button
                      (click)="onSetContent(elemento, $event)"
                      class="bg-base-status-info px-5 uppercase text-white"
                      type="button"
                      translate
                    >
                      <svg-icon class="flex w-6" src="assets/icons/icon-view-fine.svg"></svg-icon>
                      <span class="ml-2 hidden lg:flex" translate> gestor-avaliacoes.caixa-alta.pre-visualizar </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</app-accordion-item>
